import { Navigate } from 'react-router-dom';
import preloadChunks from '@/routes/preloadChunks.util';
import Welcome from '@/pages/Review/Welcome';
import Approved from '@/pages/Review/Approved';
import Rejected from '@/pages/Review/Rejected';

const reviewRoutes = [
  {
    path: ':reviewerStatusId',
    children: [
      { index: true, element: <Navigate to="welcome" replace /> },
      {
        path: 'welcome',
        element: <Welcome />,
      },
      {
        path: 'document',
        lazy: async () => ({
          Component: (await preloadChunks['review.document']()).default,
        }),
      },
      { path: 'approved', element: <Approved /> },
      { path: 'rejected', element: <Rejected /> },
    ],
  },
];

export default reviewRoutes;
